import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { Body2 } from '@ui/Typography'
import { CheckIcon } from '@ui/icons/Check.icon'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { isAccountActivatedStatus } from '@model/AccountDetailedStatus'

import { Box } from '@shared/components/Box'

interface PhoneNumberStatusProps {
  isVerified?: boolean
  verify?: () => void
  showIcon?: boolean
  shouldVerify?: boolean
}

export const PhoneNumberStatus: React.FC<PhoneNumberStatusProps> = ({
  isVerified,
  verify,
  showIcon,
  shouldVerify,
}) => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  if (isVerified) {
    return (
      <Box flex align='center' gap='x8'>
        {showIcon && <CheckIcon size={16} color={'text-success-high-em'} />}
        <Body2 color='text-success-high-em'>{t('PhoneNumbers.Verified')}</Body2>
      </Box>
    )
  } else if (shouldVerify && isAccountActivatedStatus(account)) {
    return (
      <Box flex align='center' gap='x8' onClick={verify}>
        {showIcon && <WarningIcon size={16} color='text-info-med-em' />}
        <Body2 color='text-info-med-em'>{t('PhoneNumbers.Verify')}</Body2>
      </Box>
    )
  } else {
    return null
  }
}
